<template>
    <div class="project" >

      <nav class="navbar is-mobile is-medium" style="background-color: #30008A;" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
          <img id="navbar-logo" src="../../assets/projects/philips/philips.jpg" alt="Solid Logo">
      </div>
    </nav>

      <h1>  Workexperience @Philips - Projects</h1>

        <h2>UX/UI - Philips Research - R2PM</h2>
        <p>During my time at Philips Research, I was engaged in the UX/UI design
            for the “R2PM” project. This involved designing a dashboard aimed at
            managing patients, specifically tailored for smaller clinics in the US. My
            responsibilities encompassed creating intuitive workflows and generating
            design assets to support the team’s efforts in enhancing patient
            management.
        </p>

        <h2>UX/UI - Philips Design - Eagle.ai</h2>
        <p>
            At Philips Design, I contributed to the “Eagle.ai” project in the capacity of
            UX/UI design. The project focused on creating a suite of applications that
            leveraged AI to automate certain steps within the workflows of medical
            professionals, including physicians and other healthcare personnel.
            My role entailed optimizing user experience and interface design to
            seamlessly integrate AI-driven automation into medical processes.
        </p>
    </div>
  </template>
  
 <style>
@import 'project.css';
</style>